import { render, staticRenderFns } from "./InvoicesDHLFedExTNTTable.vue?vue&type=template&id=48068e08&scoped=true"
import script from "./InvoicesDHLFedExTNTTable.vue?vue&type=script&lang=js"
export * from "./InvoicesDHLFedExTNTTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesDHLFedExTNTTable.vue?vue&type=style&index=0&id=48068e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48068e08",
  null
  
)

export default component.exports